export const trackCustomEventThenRedirect = ({ category, action, label, value, url }) => (e) => {
    e.preventDefault()
    const hitCallback = () => {
        window.location.href = url
    }
    if (window.ga) {
        setTimeout(hitCallback, 1000)
        window.ga("send", {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
            hitCallback
        })
    } else {
      // we still need to redirect if GTM/GA is blocked by browsers and adBlockers
      window.location.href = url;
    }
  };